import { render, staticRenderFns } from "./GPathSessionEditV1.vue?vue&type=template&id=3b23ffdb&scoped=true"
import script from "./GPathSessionEditV1.vue?vue&type=script&lang=js"
export * from "./GPathSessionEditV1.vue?vue&type=script&lang=js"
import style0 from "./GPathSessionEditV1.vue?vue&type=style&index=0&id=3b23ffdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23ffdb",
  null
  
)

export default component.exports